import { render } from "./ProductImages.vue?vue&type=template&id=3060f36e&scoped=true"
import script from "./ProductImages.vue?vue&type=script&lang=js"
export * from "./ProductImages.vue?vue&type=script&lang=js"

import "./ProductImages.vue?vue&type=style&index=0&id=3060f36e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3060f36e"]])

export default __exports__